import React from 'react'
import PropTypes from 'prop-types'

const EllipsisIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.6" cy="8" r="1.6" />
    <circle cx="8" cy="8" r="1.6" />
    <circle cx="14.4" cy="8" r="1.6" />
  </svg>
)

EllipsisIcon.propTypes = {
  className: PropTypes.string
}

EllipsisIcon.defaultProps = {
  className: ''
}

export default EllipsisIcon
